<template>
  <div ref="pdfContent" class="pdf-content">
    <Loader v-if="isLoadingData" fullPage useOverlay loader="spinner"></Loader>
  </div>
</template>

<script>
import Loader from "@/components/Loader/Loader";
import { mapGetters, mapActions, mapState } from "vuex";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { EventBus } from "./eventBus";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_SALESFORCE } from "../../../../api/api-paths";
import QRCode from "qrcode";

let APIDomain = new URL(window.location.href);
if(APIDomain.hostname != "localhost"){
  pdfMake.vfs = pdfFonts.pdfMake.vfs
}

export default {
  components: {
    Loader,
    QRCode,
  },
  data() {
    return {
      name: "PrintLabel",
      isLoadingData: false,
      projectID: '',
      partNo: 0,
      header: [],
      companyInfo: [],
      tableData: [],
      lengthData: [],
      imageUrl: "",
      imageSrc: "", // Base64 data of the image
      employee_nik: null,
      employee_name: null,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
  },
  created() {
    this.employee_nik = this.userData.nik;
    this.employee_name = this.userData.fullname;
    this.imgLogo();
    EventBus.$on("open-printlabel", (data, index) => {
      this.projectID = data;
      this.partNo = index;
      this.loadData();
    });
  },
  beforeDestroy() {
    EventBus.$off("open-printlabel");
  },
  methods: {
    totalQty(index) {
      if (index < 0 || index >= this.tableData.length) {
        return 0; // Return 0 if index is out of bounds
      }

      const boxNo = this.header[index].noBox;
      const boxData = this.tableData.find((box) => box.boxNo === boxNo);

      if (!boxData) {
        return 0; // Return 0 if no data found for the box
      }

      return boxData.people.reduce((sum, person) => {
        return (
          sum +
          person.uniforms.reduce((uniformSum, uniform) => {
            return uniformSum + uniform.qty;
          }, 0)
        );
      }, 0);
    },

    // setData() {
    //   this.loadData();
    // },
    loadData() {
      this.isLoadingData = true;
      localStorage.removeItem("redirect_url");
      fnPOST(APIPATH_SALESFORCE.getOrderBox, {
        project_id: this.projectID,
        part_no: this.partNo,
        category:'list',
        created_by:this.employee_nik,
        created_by_name:this.employee_name
      })
        .then((rsp) => {
          this.isLoadingData = false;
          let data = rsp.data.payload;
          if (!Array.isArray(data)) {
            console.error("Expected data.payload to be an array.");
            return;
          }

          let header = [];
          let companyInfo = [];
          let tableData = [];

          let currentBoxNo = null;

          data.forEach((val) => {
            if (val.box_no !== currentBoxNo) {
              currentBoxNo = val.box_no;
              console.log(val);

              // Add header and company info only once per box_no
              // Initialize a new box entry in tableData
              tableData.push({
                boxNo: val.box_no,
                people: [],
              });
            }

            // Find the entry for the current box number
            let boxEntry = tableData.find(
              (entry) => entry.boxNo === val.box_no
            );

            // If boxEntry is not found, create a new entry
            if (!boxEntry) {
              boxEntry = {
                boxNo: val.box_no,
                people: [],
              };
              tableData.push(boxEntry);
            }

            // Check if the person already exists in the people array
            let person = boxEntry.people.find((p) => p.nik === val.nik);

            if (!person) {
              // If the person does not exist, add a new entry
              person = {
                box_no: val.box_no,
                name_customer: val.name_customer,
                po: val.no_po,
                address: val.address,
                name: val.name,
                nik: val.nik,
                division: val.division,
                department: val.department,
                jabatan: val.position,
                gender: val.gender,
                uniforms: [],
                total: 0,
              };
              boxEntry.people.push(person);
            }

            // Add the uniform data and update the total
            person.uniforms.push({
              article: val.article,
              color: val.color,
              type: val.item,
              size: val.size,
              qty: parseInt(val.qty),
            });

            person.total += parseInt(val.qty);
          });

          // Set the data properties
          this.header = header;
          this.companyInfo = companyInfo;
          this.tableData = tableData;

          this.generatePdf();
          // console.log("Header:", this.header);
          // console.log("Company Info:", this.companyInfo);
          // console.log("Table Data:", this.tableData);
        })
        .catch((err) => {
          this.isLoadingData = false;
          if (err.response.status !== 401) {
            this.showNotification({
              type: "error",
              message: "Failed, Please Try Again",
            });
          }
        })
        .finally(() => {
          // stop loading
          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);
        });
    },
    imgLogo() {
      let APIDomain = new URL(window.location.href);
      let APIPort = "8005";
      let protocol = "https://";
      let APIUrl = protocol + APIDomain.hostname + ":" + APIPort;
      if (APIDomain.hostname == "localhost") {
        APIUrl = "https://testapps.bbi-apparel.com:8005";
      }
      this.imageUrl = APIUrl + "/media/bbi-logo.png";
    },

    async generateQRCode(text) {
      try {
        let qrCodeDataUrl = await QRCode.toDataURL(text, {
          errorCorrectionLevel: "H",
        });
        return qrCodeDataUrl;
      } catch (err) {
        console.error("Error generating QR code:", err);
        return "";
      }
    },

    async convertImage(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error("Error converting image:", error);
        return null;
      }
    },
    async generatePdf() {
      // Optionally handle image conversion
      // this.imageSrc = await this.convertImage(this.imageUrl);

      let content = [];
      this.isLoadingData = true;

      let page = 0;
      // Iterate over tableData
      this.tableData.forEach((item, index) => {
        const tableBody = [
          [
            { text: "BOX", style: "header2" },
            { text: "PERUSAHAAN", style: "header2" },
            { text: "PO", style: "header2" },
            { text: "ALAMAT", style: "header2" },
            { text: "NO", style: "header2" },
            { text: "NAMA", style: "header2" },
            { text: "NIK", style: "header2" },
            { text: "L/P", style: "header2" },
            { text: "DEPARTMENT", style: "header2" },
            { text: "ARTIKEL", style: "header2" },
            { text: "SERAGAM", style: "header2" },
            { text: "SZ", style: "header2" },
            { text: "QTY", style: "header2" },
            { text: "TL", style: "header2" },
            { text: "CHK", style: "header2" },
          ],
        ];

        let len = 0;

        item.people.forEach((uniforms) => {
          uniforms.uniforms.forEach(() => {
            len = len + 1;
          });
        });
        console.log(len);
        let no = 0;
        // Populate table rows
        item.people.forEach((people) => {
          no += 1;
          people.uniforms.forEach((uniforms, uIndex) => {
            const row = [
              {
                text: no === 1 ? people.box_no || "" : "",
                rowSpan: uIndex === 0 ? len : 1,
                style: "rowContent",
              },
              {
                text: no === 1 ? people.name_customer || "" : "",
                rowSpan: uIndex === 0 ? len : 1,
                style: "rowContent",
              },
              {
                text: no === 1 ? people.po || "" : "",
                rowSpan: uIndex === 0 ? len : 1,
                style: "rowContent",
              },
              {
                text: no === 1 ? people.address || "" : "",
                rowSpan: uIndex === 0 ? len : 1,
                style: "rowContent",
              },
              {
                text: uIndex === 0 ? no.toString() : "",
                rowSpan: uIndex === 0 ? people.uniforms.length : 1,
                style: "rowContent",
              },
              {
                text: uIndex === 0 ? people.name || "" : "",
                rowSpan: uIndex === 0 ? people.uniforms.length : 1,
                style: "rowContent",
              },
              {
                text: uIndex === 0 ? people.nik || "" : "",
                rowSpan: uIndex === 0 ? people.uniforms.length : 1,
                style: "rowContent",
              },
              {
                text: uIndex === 0 ? people.gender || "" : "",
                rowSpan: uIndex === 0 ? people.uniforms.length : 1,
                style: "rowContent",
              },
              {
                text: uIndex === 0 ? people.department || "" : "",
                rowSpan: uIndex === 0 ? people.uniforms.length : 1,
                style: "rowContent",
              },
              {
                text: `${uniforms.article}\n${uniforms.color || ""}`,
                style: "rowContent",
              },
              { text: uniforms.type || "", style: "rowContent" },
              { text: uniforms.size || "", style: "rowContent" },
              { text: uniforms.qty || "", style: "rowContent" },
              {
                text: uIndex === 0 ? people.total || "" : "",
                rowSpan: uIndex === 0 ? people.uniforms.length : 1,
                style: "rowContent",
              },
              { text: "", style: "rowContent" },
            ];
            tableBody.push(row);
          });
        });

        // Add table to content with centered alignment
        content.push({
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto",80, 40, 100, 40, 70, 40, 25, 40, 65,65,"auto","auto","auto","auto"], // Set fixed width for 'ARTIKEL' (e.g., 50 units)
            body: tableBody,
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => "#000000",
            vLineColor: () => "#000000",
          },
          margin: [10, 5, 10, 5], // Adjust margins to create vertical space
          alignment: "center", // Center the table horizontally
        });

        // Add page break if necessary
        // if (page < this.tableData.length - 1) {
        //   content.push({ text: "", pageBreak: "after" });
        // }
        // page = page + 1;
      });

      const docDefinition = {
        content: content,
        pageSize: "A4", // A4 page size
        pageOrientation: "landscape", // Landscape orientation
        pageMargins: [10, 10, 10, 10], // Adjust margins as needed
        styles: {
          header: {
            fontSize: 11,
            bold: true,
          },
          companyInfo: {
            fontSize: 11,
            margin: [0, 2, 0, 2],
          },
          header2: {
            fillColor: "#f2f2f2",
            fontSize: 11,
            bold: true,
            margin: [0, 0, 0, 0], // No margin
            padding: [2, 2, 2, 2], // Padding: [top, left, bottom, right]
            alignment: "center", // Center align text
          },
          rowContent: {
            fontSize: 9,
            margin: [0, 0, 0, 0], // No margin
            padding: [2, 2, 2, 2], // Padding: [top, left, bottom, right]
          },
          footerTotal: {
            fontSize: 11,
            bold: true,
            alignment: "right", // Right align text
            fillColor: "#f2f2f2",
          },
          tableExample: {
            fontSize: 9, // Adjust font size for table content
            verticalAlignment: "middle",
          },
        },
      };

      pdfMake.createPdf(docDefinition).open();
      this.isLoadingData = false;
    },
  },
};
</script>

<style scoped>
.pdf-content {
  display: block;
}
.header .title {
  display: flex;
  justify-content: space-between;
}
.company-info span,
.company-info p {
  margin: 0;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  border: 1px solid black;
  padding: 5px;
}
th {
  background-color: #f2f2f2;
}
.total {
  text-align: right;
  font-weight: bold;
}
</style>
